import {
  DayOfWeek,
  PoEmailFrequency,
} from "@redotech/redo-inventory-common/po-email-settings";
import * as z from "zod";

export const getPoEmailSettings = {
  name: "getPoEmailSettings" as const,
  input: z.object({}),
  output: z
    .object({
      id: z.string(),
      accountId: z.string(),
      enabled: z.boolean(),
      recipients: z.array(z.string()),
      frequency: z.nativeEnum(PoEmailFrequency),
      dayOfWeek: z.nativeEnum(DayOfWeek),
      lastSentAt: z.coerce.date().nullable(),
      nextRunAt: z.coerce.date().nullable(),
      createdAt: z.coerce.date(),
      updatedAt: z.coerce.date(),
    })
    .nullable(),
};
